module.exports = __webpack_public_path__ + "static/media/bandera-espa-a.f9a60b38.svg";